<template>
  <v-app id="inspire" style="background: white;">
    <img src="/static/sticker/sticker banner.jpg" style="width: 100%;" />
<v-layout row wrap style="height: 100%; margin:50px;">  
  <v-flex md1 lg1 xl1 ></v-flex>
      <v-flex md3 lg3 xl3 >
    <img src="https://chat-public.one.th:8034/getmessage_sticker/bucket-sticker/S75d07738b61a535cbfaed2419e6c0116/S75d07738b61a535cbfaed2419e6c0116_0.png" style="width: 200px;">
 </v-flex>
 <v-flex md7 lg7 xl7>
  <div style="margin-top: 50px; font-size: 18px;" >&emsp;&emsp;&emsp;&emsp;<strong>One Chat</strong> เป็นแอปพลิเคชั่นหนึ่งในตระกูลของ <strong><a href="https://one.th/" target="_blank">One Platform</a></strong> ใช้สำหรับติดต่อสื่อสารระหว่างบุคคลทั่วไป รวมไปถึงภาคธุรกิจ และรัฐบาล<br>
     &emsp;&emsp;&emsp;&emsp;โดยมีน้อง wonder เป็นสติ๊กเกอร์มาสคอต 
   </div>
  </v-flex>
</v-layout>


  </v-app>
</template>

<script>
export default {
  data: () => ({
  }),
  props: {
    source: String
  },
  methods: {
  },
  components: {
  },
  computed: {
  },
  watch: {
  },
  created () {
  }
}
</script>
<style type="text/css" scope>
  b {
    font-weight: 900 !important;
    
  }
  
.tabss{
  background-color: #1da1f2 !important;
}
.tabssright{
  background-color: #2562af !important;
}
.tabs__bar .icon--right {
    right: 10px !important;
}
.tabs__bar .icon--left {
    left: 10px !important;
}

.tabs:not(.tabs--grow):not(.tabs--mobile) .tabs__item {
    padding: 0 15px !important;
}
.alligator-turtle {
  
  object-fit: cover;
  object-position: 50% 0;
}
.text {
  white-space: nowrap; 
  width: 100px; 
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
  padding-top: 0px;
  font-family: 'CS ChatThaiUI' !important;
}
.textlayout {
  white-space: nowrap; 
  width: 9em; 
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 0vw;
  padding-top: 1vh; 
  padding-left: 2vw; 
  font-family: 'CS ChatThaiUI' !important;
  font-size: 18px;
  padding-bottom: 0px; 
  color: white;
  text-transform: none;
}
span.badge__bage.red {
  left: 27px;
}
.icon {
  font-size: 25px!important;
}
.badge--overlap .badge__badge {
  top: -12px;
  right: -9px;
}
.application .theme--light.list .list__tile:not(.list__tile--active), .theme--light .list .list__tile:not(.list__tile--active) {
  padding: 2vw !important;
}
/*.application .theme--light.list, .theme--light .list {
  padding: 2vw !important;
}*/
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.listmenuweb {
  padding-left: 8px !important;
}
.list {
  padding-left: 8px !important;
}
.stickerlist {
  cursor: pointer;
}
.stickerlist:hover {
  background: aliceblue;
}
</style>


// WEBPACK FOOTER //
// src/components/sticker/homepage.vue